/* eslint-disable @typescript-eslint/naming-convention */
import { MembershipProduct, NameTid } from '@app/core/models';
import { SwiperOptions } from 'swiper';

export interface MembershipCategories extends NameTid {
  productId?: string;
}

/**
 * Configuration for faq based by the membership plans.
 */
export const categoryTerms: MembershipCategories[] = [
  {
    name: 'kiter',
    tid: 407,
    productId: '2',
    // tid: 405, // stage
  },
  {
    name: 'instructor',
    tid: 408,
    productId: '3',
    // tid: 406, // stage
  },
  {
    name: 'assistant',
    tid: 409,
    productId: '22',
    // tid: 407, // stage
  },
  {
    name: 'examiner',
    tid: 410,
    // tid: 408, // stage
  },
];
/**
 * Configuration for swiper.
 */
export const swiperConfig: SwiperOptions = {
  direction: 'horizontal',
  autoplay: {
    delay: 3000,
    stopOnLastSlide: false,
    reverseDirection: false,
    disableOnInteraction: false,
  },
  pagination: true,
  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
    disabledClass: 'disabled',
  },
  loop: true,
  breakpoints: {
    1024: {
      slidesPerView: 4,
    },
    768: {
      slidesPerView: 3,
    },
    736: {
      slidesPerView: 2,
    },
    690: {
      slidesPerView: 3,
    },
    480: {
      slidesPerView: 2,
    },
    320: {
      slidesPerView: 1,
    },
  },
};

/**
 * Type to define the configuration for the action to pay a membership.
 */
export type MembershipPayActionConfiguration = {
  /**
   * Initial condition to meet to enable this configuration.
   */
  condition: () => boolean;
  actions: {
    /**
     * Product ids to enable this action.
     */
    productIds: string[];
    /**
     * Disable the button to pay if true.
     */
    disableButtonToPay?: boolean;
    /**
     * Action to take if the initial condition and product ids are met.
     */
    action?: (product: MembershipProduct) => void;
  }[];
};
